import React, {useState} from 'react';
import {Card, Carousel, Col, Container, Row} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './ServicesSection.module.scss';
import {ChevronLeft, ChevronRight} from 'react-bootstrap-icons';
import SectionTagCopy from "../../../../components/SectionTagCopy/SectionTagCopy";

interface ServiceItem {
    id: number;
    title: string;
    description: string;
    icon: string;
}

const ServicesSection = () => {
    const services: ServiceItem[] = [
        {
            id: 1,
            title: "УЗИ диагностика",
            description: "Современное ультразвуковое исследование для точной диагностики",
            icon: "📊",
        },
        {
            id: 2,
            title: "Лабораторная диагностика",
            description: "Анализы крови, мочи для точной постановки диагноза и лечения",
            icon: "🔬",
        },
        {
            id: 3,
            title: "Рентгенография",
            description: "Единственный рг аппарат для мелких животных, ближайший в г. Краснокамск",
            icon: "🩻",
        },
        {
            id: 4,
            title: "Терапия",
            description: "Профилактика и лечение мелких заболеваний домашних животных",
            icon: "💊",
        },
        {
            id: 5,
            title: "Хирургия, травмотология и ортопедия",
            description: "Проведение операций разных сложностей, в том числе ортопедических",
            icon: "🔪",
        },
        {
            id: 6,
            title: "Стоматология",
            description: "Удаление зубов, удаление зубного камня, гигиена полости рта для животных",
            icon: "🦷",
        },
    ];

    const [activeIndex, setActiveIndex] = useState(0);
    const [activeIndexMobile, setActiveIndexMobile] = useState(0);
    const [activeIndexTablet, setActiveIndexTablet] = useState(0);

    // Функция для группировки сервисов в слайды по разным брейкпоинтам
    const getServiceSlides = () => {
        // Для мобильных (xs): 1 карточка
        const mobileSlides = [];
        for (let i = 0; i < services.length; i += 1) {
            mobileSlides.push(services.slice(i, i + 1));
        }

        // Для планшетов (sm/md): 2 карточки
        const tabletSlides = [];
        for (let i = 0; i < services.length; i += 2) {
            tabletSlides.push(services.slice(i, i + 2));
        }

        // Для десктоп (lg/xl): 3 карточки
        const desktopSlides = [];
        for (let i = 0; i < services.length; i += 3) {
            desktopSlides.push(services.slice(i, i + 3));
        }

        return {mobileSlides, tabletSlides, desktopSlides};
    };

    const {mobileSlides, tabletSlides, desktopSlides} = getServiceSlides();

    const handleSelectMobile = (selectedIndex: number) => {
        setActiveIndexMobile(selectedIndex);
    };

    const handlePrevDesktop = () => {
        setActiveIndex(prev => (prev === 0 ? desktopSlides.length - 1 : prev - 1));
    };

    const handleNextDesktop = () => {
        setActiveIndex(prev => (prev === desktopSlides.length - 1 ? 0 : prev + 1));
    };

    const handlePrevTablet = () => {
        setActiveIndexTablet(prev => (prev === 0 ? tabletSlides.length - 1 : prev - 1));
    };

    const handleNextTablet = () => {
        setActiveIndexTablet(prev => (prev === tabletSlides.length - 1 ? 0 : prev + 1));
    };

    return (
        <section id="what-do" className={styles.servicesSection}>
            <SectionTagCopy anchorId="what-do"/>
            <h1 className={styles.title}>
                Чем мы занимаемся?
            </h1>

            {/* Мобильная версия (1 карточка) - только для xs */}
            <div className={`d-block d-sm-none ${styles.mobileCarousel}`}>
                <Container>
                    <Carousel
                        activeIndex={activeIndexMobile}
                        onSelect={handleSelectMobile}
                        indicators={false}
                        prevIcon={<ChevronLeft className={styles.carouselIcon}/>}
                        nextIcon={<ChevronRight className={styles.carouselIcon}/>}
                        className={styles.customCarousel}
                    >
                        {mobileSlides.map((slide, index) => (
                            <Carousel.Item key={index}>
                                <Row className="justify-content-center">
                                    {slide.map(service => (
                                        <Col xs={12} key={service.id} className="mb-3">
                                            <Card className={styles.serviceCard}>
                                                <Card.Body className="text-center p-4">
                                                    <div className="mb-3" style={{fontSize: '3rem'}}>
                                                        {service.icon}
                                                    </div>
                                                    <Card.Title className="mb-3 fw-bold">
                                                        {service.title}
                                                    </Card.Title>
                                                    <Card.Text className="text-muted">
                                                        {service.description}
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </Container>
            </div>

            {/* Планшетная версия (2 карточки) - для sm и md */}
            <div className={`d-none d-sm-block d-lg-none ${styles.tabletCarousel}`}>

                <div className={styles.carouselWrapper}>
                    <button
                        className={styles.carouselButton}
                        onClick={handlePrevTablet}
                        aria-label="Предыдущий слайд"
                    >
                        <ChevronLeft/>
                    </button>

                    <div className={styles.carouselContainer}>
                        <Row className="g-4 justify-content-center">
                            {tabletSlides[activeIndexTablet]?.map((service) => (
                                <Col sm={6} md={6} key={service.id}>
                                    <Card className={styles.serviceCard}>
                                        <Card.Body className="text-center p-4">
                                            <div className="mb-3" style={{fontSize: '3rem'}}>
                                                {service.icon}
                                            </div>
                                            <Card.Title className="mb-3 fw-bold">
                                                {service.title}
                                            </Card.Title>
                                            <Card.Text className="text-muted">
                                                {service.description}
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </div>

                    <button
                        className={styles.carouselButton}
                        onClick={handleNextTablet}
                        aria-label="Следующий слайд"
                    >
                        <ChevronRight/>
                    </button>
                </div>

                {/* Индикаторы для планшетов */}
                <div className={styles.carouselIndicators}>
                    {tabletSlides.map((_, index) => (
                        <button
                            key={index}
                            className={`${styles.indicator} ${index === activeIndexTablet ? styles.active : ''}`}
                            onClick={() => setActiveIndexTablet(index)}
                            aria-label={`Перейти к слайду ${index + 1}`}
                        />
                    ))}
                </div>
            </div>

            {/* Десктоп версия (3 карточки) - для lg и выше */}
            <div className={`d-none d-lg-block ${styles.desktopCarousel}`}>
                <Container>
                    <div className={styles.carouselWrapper}>
                        <button
                            className={styles.carouselButton}
                            onClick={handlePrevDesktop}
                            aria-label="Предыдущий слайд"
                        >
                            <ChevronLeft/>
                        </button>

                        <div className={styles.carouselContainer}>
                            <Row className="g-4 justify-content-center">
                                {desktopSlides[activeIndex]?.map((service) => (
                                    <Col lg={4} key={service.id}>
                                        <Card className={styles.serviceCard}>
                                            <Card.Body className="text-center p-4">
                                                <div className="mb-3" style={{fontSize: '3rem'}}>
                                                    {service.icon}
                                                </div>
                                                <Card.Title className="mb-3 fw-bold">
                                                    {service.title}
                                                </Card.Title>
                                                <Card.Text className="text-muted">
                                                    {service.description}
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </div>

                        <button
                            className={styles.carouselButton}
                            onClick={handleNextDesktop}
                            aria-label="Следующий слайд"
                        >
                            <ChevronRight/>
                        </button>
                    </div>

                    {/* Индикаторы для десктопа */}
                    <div className={styles.carouselIndicators}>
                        {desktopSlides.map((_, index) => (
                            <button
                                key={index}
                                className={`${styles.indicator} ${index === activeIndex ? styles.active : ''}`}
                                onClick={() => setActiveIndex(index)}
                                aria-label={`Перейти к слайду ${index + 1}`}
                            />
                        ))}
                    </div>
                </Container>
            </div>
        </section>
    );
};

export default ServicesSection;
